import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import Login from './pages/Login';
import Subscription from './pages/Subscription';
import { isLoggedIn, clearSession } from './utils/appUtils';
import NotFound from './pages/NotFound';
import ForgotPassword from './pages/ForgotPassword';

if (!isLoggedIn()) clearSession();

export default function Router() {
  return useRoutes([
    isLoggedIn()
      ? {
          path: '/',
          children: [
            { path: '/', element: <Navigate to='/subscription' /> },
            { path: '/subscription', element: <Subscription /> },
          ],
        }
      : {
          path: '/',
          children: [
            { path: '/', element: <Navigate to='/login' /> },
            { path: 'login', element: <Login /> },
            { path: 'forgotPassword', element: <ForgotPassword /> },
          ],
        },
    // {
    //   path: '/',
    //   children: [
    //     { path: '404', element: <NotFound /> },
    //     { path: '*', element: <Navigate to='/404' /> },
    //   ],
    // },
    { path: '*', element: <Navigate to='/' replace /> },
  ]);
}
